import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./userRegister.css";
import Header from "../../components/header/header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSave,
  faWindowClose,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons"; // Importe os ícones de olho e olho cortado
/*import {
  getUserById,
  getUserUpdate,
  getUsersCadastro,
} from "../../services/api_cadastro_users";*/
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { getUserById, getUserCadastro, getUserUpdate } from "../../services/api_users_register";

const UserRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id

  const [nome, setNome] = useState("");
  const [password, setPassword] = useState("");
  const [login, setUsername] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // Adicione o estado para controlar a visibilidade da senha
  const [isSaving, setSaving] = useState(false)


  const inputRefs = {
    Nome: useRef(null),
    Senha: useRef(null),
    Email: useRef(null)
  };

  // crud com o backend (buscar o id do usuário)
  useEffect(() => {
    setLoading(true)
    const fetchUser = async () => {
      try {
        const response = await getUserById(id);
        //console.log(response);
        const user = response.data; // Corrigido para acessar response.data.empresa
        if (user) {
          setNome(user.nome || "");
          setUsername(user.username || "");
          //setPassword(user.password || "");
        } else {
          console.error("Dados não encontrados na resposta:", response);
        }
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    if (id) {
      fetchUser();
    }
      setLoading(false)
  }, [id]);


  const validarInputs = () => {
    if (id) {
      if (!nome || !login) {
        Swal.fire({
          icon: "warning",
          title: "Oops!",
          text: "Os campos Nome e E-mail não podem ficar vazios.",
        });

        return false;
      }

      return true;
    } else {
      if (!nome || !password || !login) {
        Swal.fire({
          icon: "warning",
          title: "Oops!",
          text: "O preenchimento de todos os campos são obrigatórios",
        });

        return false;
      }
      return true;
    }
  };


// crud com o backend (realizar o cadastro do usuário)
  const addCadastro = async (body) => {
    try {
      const response = await getUserCadastro(body);

      if (response && response.status === 200) {
        //console.log(response, 'novo usuário')
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      console.error("Erro ao cadastrar unidade:", error);
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  // crud com o backend (editar o perfil do usuário)
  const newUpdate = async (body) => {
    try {
      const response = await getUserUpdate(id, body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      console.error(error)
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = async () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        nome,
        login,
        password,
      };
      //console.log(body, 'formulário enviado corretamente')
      if (id) {
        !password && delete body.password;
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const handleCaracteres = (e) => {
    const value = e.target.value;
    if (value.length <= 30) {
      setNome(value);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O campo não pode ultrapassar 30 caracteres",
      });
    }
  };

  const handleEmail = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setUsername(value);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O campo E-mail não pode ultrapassar 50 caracteres",
      });
    }
  };
  const handlePassword = (e) => {
    const value = e.target.value;
    if (value.length <= 12) {
      setPassword(value);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O campo Senha não pode ultrapassar 12 caracteres",
      });
    }
  };

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === 'Enter' && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus = nextFieldRef.current.inputRef || nextFieldRef.current;
  
      if (typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      } else {
        console.warn('O elemento de input não tem o método focus.');
      }
    }
  };
  

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Gerenciamento/ Cadastros de Usuário" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formNome">
                  <Form.Label>Nome</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o nome"
                    value={nome}
                    onChange={handleCaracteres}
                    ref={inputRefs.Nome}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Email)}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formEmail">
                  <Form.Label>E-mail</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o e-mail"
                    value={login}
                    disabled = {!!id}
                    onChange={handleEmail}
                    ref={inputRefs.Email}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Senha)}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formSenha">
                  <Form.Label>Senha</Form.Label>
                  <div className="input-group">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Digite a Senha"
                      value={password}
                      onChange={handlePassword}
                      ref={inputRefs.Senha}
                    />
                    <Button
                      variant="outline-secondary"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <FontAwesomeIcon
                        icon={showPassword ? faEyeSlash : faEye}
                      />{" "}
                    </Button>
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>
    </>
  );
};

export default UserRegister;